import axios from '../config/axiosConfig';

const API_URL = '/siem-correlation';

// Trigger correlation for a single action
const triggerCorrelation = async (actionId, options = {}) => {
  const response = await axios.post(`${API_URL}/trigger/${actionId}`, options);
  return response.data;
};

// Get correlation status (lightweight)
const getStatus = async (actionId) => {
  const response = await axios.get(`${API_URL}/status/${actionId}`);
  return response.data;
};

// Get full correlation results
const getResults = async (actionId) => {
  const response = await axios.get(`${API_URL}/results/${actionId}`);
  return response.data;
};

// Cancel running correlation
const cancelCorrelation = async (actionId) => {
  const response = await axios.post(`${API_URL}/cancel/${actionId}`);
  return response.data;
};

// Trigger batch correlation
const triggerBatch = async (options = {}) => {
  const response = await axios.post(`${API_URL}/trigger-batch`, options);
  return response.data;
};

// Verdict display configuration
const verdictConfig = {
  not_detected: {
    label: 'Not Detected',
    color: 'green',
    bgLight: 'bg-green-100 text-green-800',
    bgDark: 'bg-green-900/30 text-green-300',
    borderLight: 'border-green-300',
    borderDark: 'border-green-700',
    icon: 'check-circle'
  },
  event_logged: {
    label: 'Event Logged',
    color: 'yellow',
    bgLight: 'bg-yellow-100 text-yellow-800',
    bgDark: 'bg-yellow-900/30 text-yellow-300',
    borderLight: 'border-yellow-300',
    borderDark: 'border-yellow-700',
    icon: 'file-alt'
  },
  alert_generated: {
    label: 'Alert Generated',
    color: 'red',
    bgLight: 'bg-red-100 text-red-800',
    bgDark: 'bg-red-900/30 text-red-300',
    borderLight: 'border-red-300',
    borderDark: 'border-red-700',
    icon: 'bell'
  },
  inconclusive: {
    label: 'Inconclusive',
    color: 'gray',
    bgLight: 'bg-gray-100 text-gray-700',
    bgDark: 'bg-gray-700 text-gray-300',
    borderLight: 'border-gray-300',
    borderDark: 'border-gray-600',
    icon: 'question-circle'
  }
};

const getVerdictConfig = (verdict) => {
  return verdictConfig[verdict] || verdictConfig.inconclusive;
};

// Status display config
const statusConfig = {
  none: { label: 'Not Checked', color: 'gray' },
  pending: { label: 'Pending', color: 'blue' },
  running: { label: 'Running', color: 'blue' },
  completed: { label: 'Completed', color: 'green' },
  failed: { label: 'Failed', color: 'red' },
  partial: { label: 'Partial', color: 'yellow' }
};

const getStatusConfig = (status) => {
  return statusConfig[status] || statusConfig.none;
};

const siemCorrelationService = {
  triggerCorrelation,
  getStatus,
  getResults,
  cancelCorrelation,
  triggerBatch,
  verdictConfig,
  getVerdictConfig,
  statusConfig,
  getStatusConfig
};

export default siemCorrelationService;
